import * as cookies from '@rambler-id/cookies'

export const OAUTH_NONCE = 'r_id_oauth_nonce'

const ONE_HOUR = 1 / 24

export const setValidNonce = (nonce: string): void => {
  cookies.setItem(OAUTH_NONCE, nonce, {expires: ONE_HOUR})
}
